import gmapHelper from '../utils/gmap/gmapHelper'

export const useGMap = () => {
  const { $gMapLoader: gMapLoader } = useNuxtApp()

  return { gMapLoader, gmapHelper }
}
